import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
const defaultOptions = {} as const;

export const SalesPortalCreateOrderGuideFromMenuDocument = gql`
  mutation SalesPortalCreateOrderGuideFromMenu(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
  ) {
    createOrderGuideFromMenu(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      order_guide_collection_uuid
      order_guide_partition_uuid
    }
  }
`;
export type SalesPortalCreateOrderGuideFromMenuMutationFn =
  Apollo.MutationFunction<
    Types.SalesPortalCreateOrderGuideFromMenuMutation,
    Types.SalesPortalCreateOrderGuideFromMenuMutationVariables
  >;
export function useSalesPortalCreateOrderGuideFromMenuMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SalesPortalCreateOrderGuideFromMenuMutation,
    Types.SalesPortalCreateOrderGuideFromMenuMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SalesPortalCreateOrderGuideFromMenuMutation,
    Types.SalesPortalCreateOrderGuideFromMenuMutationVariables
  >(SalesPortalCreateOrderGuideFromMenuDocument, options);
}
export type SalesPortalCreateOrderGuideFromMenuMutationHookResult = ReturnType<
  typeof useSalesPortalCreateOrderGuideFromMenuMutation
>;
export type SalesPortalCreateOrderGuideFromMenuMutationResult =
  Apollo.MutationResult<Types.SalesPortalCreateOrderGuideFromMenuMutation>;
export type SalesPortalCreateOrderGuideFromMenuMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SalesPortalCreateOrderGuideFromMenuMutation,
    Types.SalesPortalCreateOrderGuideFromMenuMutationVariables
  >;
